import type { Location } from 'history';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { compose } from 'recompact';

import { errorBoundary } from 'src/app/hocs';
import type { RootState } from 'src/app/state/store';
import { PAGE_ALERT_TYPES } from 'src/consts';

import { CheckoutRenderer } from '.';

const mapStateToProps = (state: RootState) => {
  const shouldShowRefrigerationAlert = (state?.pageAlert?.type ?? null) === PAGE_ALERT_TYPES.refrigerationPageAlert;

  return {
    shouldShowRefrigerationAlert,
  };
};

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface CheckoutLayoutProps extends PropsFromRedux {
  location: Location;
}

export const Checkout = compose(errorBoundary, connector)(CheckoutRenderer);

Checkout.displayName = CheckoutRenderer.displayName;
